import { useState, useEffect } from 'react';
import { type CookieConsent, readConsentCookie, writeConsentCookie } from '../cookies';

const defaultConsent: CookieConsent = {
  v: 1,
  shown: false,
  functional: false,
  analytics: false,
  marketing: false,
  timestamp: 0,
};

export function useCookieConsent() {
  const [consent, setConsent] = useState<CookieConsent | null>(null);

  useEffect(() => {
    setConsent(readConsentCookie() ?? defaultConsent);
  }, []);

  const update = (prefs: Partial<CookieConsent>) => {
    const next = { ...(consent ?? defaultConsent), ...prefs, timestamp: Date.now() };
    writeConsentCookie(next);
    setConsent(next);
  };

  const dismiss = () => update({ shown: true });

  return {
    consent,
    update,
    dismiss,
    isShown: consent?.shown ?? false,
  };
}
